import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

export const LANGUAGES = [
    { code: "fr", label: "Français", flag: "🇫🇷" },
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "es", label: "Español", flag: "🇪🇸" },
    { code: "it", label: "Italiano", flag: "🇮🇹" },
    { code: "pt-BR", label: "Português (Brasil)", flag: "🇧🇷" },
    { code: "pt-PT", label: "Português (Portugal)", flag: "🇵🇹" },
];

const LangContext = createContext({ lang: "fr", setLang: () => {} });

export function LangProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "fr";
        return localStorage.getItem("tk_lang") || "fr";
    });

    useEffect(() => {
        document.documentElement.setAttribute("lang", lang);
        localStorage.setItem("tk_lang", lang);
    }, [lang]);

    const setLang = useCallback((next) => {
        if (LANGUAGES.some((l) => l.code === next)) setLangState(next);
    }, []);

    const value = useMemo(() => ({ lang, setLang }), [lang, setLang]);

    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
